import { useState } from 'react'
import { Icon } from '@iconify/react'

import { Button } from '@pepper/ui'

import ChangeKeywordModal from '../../ChangeKeywordModal/ChangeKeywordModal'
import type { GapReport, GapReportDocument } from '@pepper/utils/src/types/seo'

import s from './TargetStat.module.css'

type Props = {
  document: GapReportDocument['document']
  report: GapReport
}

const TargetStat = ({ document, report }: Props) => {
  const isPublic = window.location.pathname.includes('content-refresh-report')
  const [openModal, setOpenModal] = useState(false)

  return (
    <div className={s.targetWrapper}>
      <div className={s.top}>
        <p className={s.title}>Target keyword</p>
        {!isPublic && (
          <Button
            type="link"
            className={s.btn}
            iconPlacement="right"
            icon={<Icon icon="lucide:edit" />}
            onClick={() => setOpenModal(true)}
          >
            Change keyword
          </Button>
        )}
      </div>
      <div className={s.bottom}>
        <h4 className={s.keyword}>{document?.target_keyword_stats.keyword}</h4>
        <div className={s.stats}>
          <div>
            <div className={s.value}>
              {document?.target_keyword_stats.position === 0
                ? '>100'
                : document?.target_keyword_stats.position}
            </div>
            <p>Your Position</p>
          </div>
          <div>
            <div className={s.value}>
              {new Intl.NumberFormat('en-US', {
                notation: 'compact',
                compactDisplay: 'short',
              }).format(document?.target_keyword_stats.volume)}
            </div>
            <p>Volume</p>
          </div>
          <div>
            <div className={s.value}>
              {document?.target_keyword_stats.difficulty}%
            </div>
            <p>Difficulty</p>
          </div>
        </div>
      </div>
      <ChangeKeywordModal
        open={openModal}
        setOpen={setOpenModal}
        report={report}
        targetKeywordStats={document.target_keyword_stats}
      />
    </div>
  )
}

export default TargetStat
